import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import parse from "html-react-parser"
import { CloseOutlined } from "@mui/icons-material"
import { Box, Chip, TextField } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import {
  useApplyDiscountCodeMutation,
  useApplyGiftCardMutation,
  useRemoveDiscountCodeMutation,
  useRemoveGiftCardMutation,
} from "src/features/checkout/storefrontApi"
import { applyGiftCard, removeGiftCard, setCart, setCheckout } from "src/features/checkout/checkoutSlice"
import { useCartDiscountCodesUpdateMutation, useCartGiftCardCodesRemoveMutation, useCartGiftCardCodesUpdateMutation } from "src/features/checkout/storefrontCartApi"

export default function GiftCardOrDiscountCodeInput() {
  const dispatch = useDispatch()
  const {appliedGiftCards, cart, checkout} = useSelector((state) => state.checkout)
  const [code, setCode] = useState("")
  const [error, setError] = useState(false)
  const [appliedDiscountCodeNotApplicable, setAppliedDiscountCodeNotApplicable] = useState(false)

  const [
    cartDiscountCodesUpdate,
    {
      isLoading: cartDiscountCodesUpdateLoading,
      data: cartDiscountCodesUpdateData,
      error: cartDiscountCodesUpdateError,
    }
  ] = useCartDiscountCodesUpdateMutation()

  const [
    cartGiftCardCodesUpdate,
    {
      isLoading: cartGiftCardCodesUpdateLoading,
      data: cartGiftCardCodesUpdateData,
      error: cartGiftCardCodesUpdateError,
    }
  ] = useCartGiftCardCodesUpdateMutation()

  const [cartGiftCardCodesRemove, {
    isLoading: CartGiftCardCodesRemoveLoading,
    data: CartGiftCardCodesRemoveData,
    error: CartGiftCardCodesRemoveError,
  }] = useCartGiftCardCodesRemoveMutation()

  const [
    applyGiftCardMutation,
    {
      isLoading: applyGiftCardLoading,
      data: applyGiftCardData,
      error: applyGiftCardError,
    },
  ] = useApplyGiftCardMutation()

  const [
    applyDiscountCodeMutation,
    {
      isLoading: applyDiscountCodeLoading,
      data: applyDiscountCodeData,
      error: applyDiscountCodeError,
    }
  ] = useCartDiscountCodesUpdateMutation()

  useEffect(() => {
    if (applyDiscountCodeData) {
      if (
        applyDiscountCodeData.checkoutDiscountCodeApplyV2.checkoutUserErrors
          .length
      ) {
        const responseError =
          applyDiscountCodeData.checkoutDiscountCodeApplyV2
            .checkoutUserErrors[0]
        if (responseError.code === "DISCOUNT_NOT_FOUND") {
          applyGiftCardMutation({
            checkoutId: checkout.id,
            giftCardCode: code,
          })
        } else if (responseError.message) {
          setError(responseError.message)
          setCode("")
        }
      } else {
        setCode("")
      }
    }
  }, [applyDiscountCodeData])

  useEffect(() => {
    console.log('cartDiscountCodesUpdateData', cartDiscountCodesUpdateData)
    if (cartDiscountCodesUpdateData) {
      dispatch(setCart(cartDiscountCodesUpdateData.cartDiscountCodesUpdate.cart))
      let appliedCode = cartDiscountCodesUpdateData.cartDiscountCodesUpdate.cart.discountCodes.find(dc => dc.code === code)

      if (appliedCode?.applicable) {
        setCode("")
      } else {
        cartGiftCardCodesUpdate({
          cartId: cart.id,
          giftCardCodes: [...appliedGiftCards, code],
        })
      }
    }
  }, [cartDiscountCodesUpdateData])

  useEffect(() => {
    console.log('cartGiftCardCodesUpdateData', cartGiftCardCodesUpdateData, cartGiftCardCodesUpdateError);
    if (cartGiftCardCodesUpdateData?.cartGiftCardCodesUpdate?.cart) {
      dispatch(setCart(cartGiftCardCodesUpdateData.cartGiftCardCodesUpdate.cart))
      let appliedGiftCard = cartGiftCardCodesUpdateData.cartGiftCardCodesUpdate.cart.appliedGiftCards.find(gc => {
        const lastCharsFromCode = code.slice(-gc.lastCharacters.length);

        return lastCharsFromCode.toLocaleLowerCase() === gc.lastCharacters.toLocaleLowerCase();
      })
      if (appliedGiftCard) {
        dispatch(applyGiftCard(code))
      } else {
        // setError("Enter a valid discount code or gift card");
      }
      setCode("")
    }
  }, [cartGiftCardCodesUpdateData])

  useEffect(() => {
    if (applyGiftCardData) {
      if (applyGiftCardData.checkoutGiftCardsAppend.checkoutUserErrors.length) {
        const error =
          applyGiftCardData.checkoutGiftCardsAppend.checkoutUserErrors[0]
        if (error.code === "GIFT_CARD_CODE_INVALID") {
          setError("Enter a valid discount code or gift card")
        } else if (error.message) {
          setError(error.message)
        }
      }
      setCode("")
    }
  }, [applyGiftCardData])

  useEffect(() => {
    if (applyDiscountCodeError?.data?.message) {
      setError(applyDiscountCodeError.data.message)
    }
  }, [applyDiscountCodeError])

  useEffect(() => {
    if (applyGiftCardError?.data?.message) {
      setError(applyGiftCardError.data.message)
    }
  }, [applyGiftCardError])

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          // applyDiscountCodeMutation({
          //   checkoutId: checkout.id,
          //   discountCode: code,
          // })
          let discountCodes = cart.discountCodes?.filter(dc => dc.applicable).map(dc => dc.code) || [];
          if (!discountCodes.includes(code)) {
            cartDiscountCodesUpdate({
              cartId: cart.id,
              discountCodes: [...discountCodes, code],
              // discountCodes: ['VD-2B-$12OFF-2021APNN', 'VD-2B-$10OFF-2021AEACS', 'VD-2B-$4OFF-2021BRCCB', 'VD-3B-$3OFF-2018ByCWCCS', 'VD-2B-$3OFF-2023APN', 'VD-3B-$4OFF-2021SVCSNC']
            })
          }
        }}
      >
        <Box display="flex" alignItems="flex-start" mt={2}>
          <TextField
            label="Gift card or discount code"
            sx={{ flex: 1, mr: 2 }}
            inputProps={{
              style: {
                backgroundColor: "white",
              },
            }}
            value={code}
            onChange={(e) => {
              setError(false)
              setCode(e.target.value)
            }}
            error={error ? true : false}
            helperText={error ? parse(error) : ""}
          />
          <LoadingButton
            type="submit"
            variant="contained"
            disabled={
              (code.length <= 0 ? true : false) ||
              cartDiscountCodesUpdateLoading ||
              cartGiftCardCodesUpdateLoading
            }
            loading={cartDiscountCodesUpdateLoading || cartGiftCardCodesUpdateLoading}
            sx={{
              height: 56,
            }}
          >
            Apply
          </LoadingButton>
        </Box>
      </form>

      <Box mt={2}>
        {cart.discountCodes?.map((discountCode) =>
          discountCode.applicable ? (
            <Chip
              key={discountCode.code}
              label={discountCode.code.toUpperCase()}
              icon={<img src={discountCodeIcon} height="18px" width="18px" />}
              onDelete={() => {
                cartDiscountCodesUpdate({
                  cartId: cart.id,
                  discountCodes: cart.discountCodes.filter(dc => dc.code !== discountCode.code).map(dc => dc.code),
                })
              }}
              deleteIcon={<CloseOutlined />}
              sx={{
                borderRadius: 1,
                mr: 1,
                mb: 1,
              }}
            />
          ) : undefined,
        )}
        {cart.appliedGiftCards?.map((giftCard) => (
          <Chip
            key={giftCard.id}
            label={`• • • • ${giftCard.lastCharacters.toUpperCase()}`}
            icon={<img src={giftCardIcon} height="18px" width="18px" />}
            onDelete={() => {
              cartGiftCardCodesRemove({
                cartId: cart.id,
                appliedGiftCardIds: [giftCard.id],
              })
              dispatch(removeGiftCard(appliedGiftCards.find(appliedGiftCard => {
                const lastCharsFromCode = appliedGiftCard.slice(-giftCard.lastCharacters.length);

                return lastCharsFromCode.toLocaleLowerCase() === giftCard.lastCharacters.toLocaleLowerCase();
              })))
            }}
            deleteIcon={<CloseOutlined />}
            sx={{
              borderRadius: 1,
              mr: 1,
              mb: 1,
            }}
          />
        ))}
      </Box>
    </>
  )
}

const giftCardIcon =
  "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTQiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0yLjEgN3Y1LjEzYzAgLjI2LjIxLjQ3LjQ3LjQ3SDdNMi4xIDdoLS4yM2EuNDcuNDcgMCAwIDEtLjQ3LS40N1Y0LjY3YzAtLjI2LjIxLS40Ny40Ny0uNDdoMS40ODdNMi4xIDdIN200LjkgMHY1LjEzYzAgLjI2LS4yMS40Ny0uNDcuNDdIN00xMS45IDdoLjIzYy4yNiAwIC40Ny0uMjEuNDctLjQ3VjQuNjdhLjQ3LjQ3IDAgMCAwLS40Ny0uNDdoLTEuNTg3TTExLjkgN0g3bTAgMHY1LjZtMC04LjRIMy4zNTdNNyA0LjJzLS4yNzYtMi44LTIuNTQtMi44Yy0yLjI2MyAwLTEuMTAzIDIuOC0xLjEwMyAyLjhNNyA0LjJoMy41NDNNNyA0LjJzLjE3Ni0yLjggMi40NC0yLjhjMi4yNjMgMCAxLjEwMyAyLjggMS4xMDMgMi44IiBzdHlsZT0iZmlsbDogbm9uZTsgc3Ryb2tlOiByZ2IoMTAyLCAxMDIsIDEwMik7Ii8+Cjwvc3ZnPg=="

const discountCodeIcon =
  "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTQiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0gNi44NTggMS4zNCBMIDExLjgyMiAxLjM0IEMgMTIuMDE1IDEuMzQgMTIuMTcyIDEuNDk2IDEyLjE3MiAxLjY5IEwgMTIuMTcyIDYuNjU0IEMgMTIuMTcyIDYuODM5IDEyLjA5OCA3LjAxNyAxMS45NjcgNy4xNDkgTCA3LjA2NCAxMi4wNTMgQyA2Ljc5IDEyLjMyNiA2LjM0NyAxMi4zMjYgNi4wNzQgMTIuMDUzIEwgMS40NTkgNy40MzggQyAxLjE4NSA3LjE2NCAxLjE4NSA2LjcyMSAxLjQ1OSA2LjQ0OCBMIDYuMzY0IDEuNTQ1IEMgNi40OTUgMS40MTMgNi42NzMgMS4zNCA2Ljg1OSAxLjM0IEwgNi44NTggMS4zNCBaIiBzdHlsZT0iZmlsbDogbm9uZTsgc3Ryb2tlOiByZ2IoMTAyLCAxMDIsIDEwMik7Ii8+CiAgPGNpcmNsZSBjeD0iOS4xIiBjeT0iNC45IiByPSIwLjciIHN0eWxlPSJzdHJva2U6IHJnYigxMDIsIDEwMiwgMTAyKTsgZmlsbDogcmdiKDEwMiwgMTAyLCAxMDIpOyIvPgogIDxwYXRoIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTkuMTAyIDQuODk3aC0uMDA1di4wMDVoLjAwNXYtLjAwNVoiLz4KPC9zdmc+"
